export default __webpack_public_path__ + "static/media/perechen-napravlenii.33d42afb.pdf";